import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';
import Ctas from '../../../Core/Ctas';
import ProductIconText from '../../Optimum/OptimumProductCards/ProductIconText';

import { Wrapper, Img, Content, Title, BodyCopy } from './styles';

const SimpleImageBanner = ({ data, className = '' }) => {
  if (!data) return null;

  const {
    theme,
    heading,
    headingStyle,
    bodyCopy,
    imageDam,
    ctas,
    component,
    sectionLayout,
    backgroundColor,
    headingAlignment,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Title
          className={`${theme} ${headingStyle}`}
          $headingAlignment={headingAlignment}
          as="p"
        >
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <Title
          className={`${theme} ${headingStyle}`}
          $headingAlignment={headingAlignment}
          as="h1"
        >
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Title
          className={`${theme} ${headingStyle}`}
          $headingAlignment={headingAlignment}
          as="h2"
        >
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <Title
          className={`${theme} ${headingStyle}`}
          $headingAlignment={headingAlignment}
          as="h3"
        >
          {children}
        </Title>
      ),
    },
  };

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const { data: segment } = node;
        if (
          segment.target &&
          segment.target.__typename === 'ContentfulTitleOrImageWithIconLists'
        ) {
          return (
            <ProductIconText data={segment.target} className="image-banner" />
          );
        }
        return null;
      },
    },
  };

  return (
    <Container
      className={`${className} auto-margin simple-image-banner`}
      backgroundColor={backgroundColor}
    >
      <Wrapper className={`${component} ${sectionLayout} ${theme}`}>
        {imageDam && <Img src={imageDam} alt="" />}
        {(header || bodyCopy) && (
          <Content>
            {header && <RichText document={heading} options={header} />}
            <BodyCopy>
              {bodyCopy && <RichText document={bodyCopy} options={body} />}
              {ctas && <Ctas ctas={ctas} direction="row" />}
            </BodyCopy>
          </Content>
        )}
      </Wrapper>
    </Container>
  );
};

SimpleImageBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default SimpleImageBanner;
